import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const FiltersHeaderLoading: React.FC = () => {
  return (
    <Wrapper data-testid="categoryHeader">
      <SkeletonBlock $width="70%" $height="28px" disableSpaceBelow />
      <SkeletonBlock $width="22%" $height="28px" disableSpaceBelow />
    </Wrapper>
  );
};

const Wrapper = styled.header`
  width: calc(100% - 1.5rem);
  height: 4.375rem;
  display: flex;
  justify-content: space-between;
  padding: 0 0.75rem;
  opacity: 0.7;
  align-items: center;
`;
